"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _polished = require("polished");

var _styled = _interopRequireDefault(require("../styled"));

var _InteractionRipples = _interopRequireDefault(require("./InteractionRipples"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styled["default"].label(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  line-height: 30px;\n  overflow: visible;\n  display: inline-block;\n\n  & > span {\n    display: inline-block;\n    position: relative;\n    top: 1px;\n    margin-left: 5px;\n  }\n"])));

var Input = _styled["default"].input(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n"])), _polished.hideVisually);

var Display = _styled["default"].svg(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: inline-block;\n  height: 14px;\n  vertical-align: middle;\n\n  background-color: transparent;\n  border-radius: 3px;\n  border: 2px solid ", ";\n\n  @media (hover: hover) {\n    ", ":hover & {\n      background-color: ", ";\n    }\n  }\n"])), function (props) {
  return props.theme.foreground;
}, Wrapper, function (props) {
  return (0, _polished.transparentize)(0.7, props.theme.foreground);
});

var PATH_LENGTH = 41.37120056152344;

var Checkmark = _styled["default"].path(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  fill: none;\n  transform-origin: center;\n  transform: scale(0.6);\n\n  stroke: ", ";\n  stroke-dashoffset: ", ";\n  stroke-width: 6.28;\n  stroke-dasharray: ", ";\n  stroke-linecap: square;\n\n  ", ":checked + ", " & {\n    stroke-dashoffset: 0;\n    transition: stroke-dashoffset 250ms cubic-bezier(0.25, 0.8, 0.25, 1) 150ms;\n  }\n"])), function (props) {
  return props.theme.foreground;
}, PATH_LENGTH, PATH_LENGTH, Input, Display);

var InteractionWrapper = _styled["default"].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  padding: 3px;\n  display: inline-block;\n  position: relative;\n  overflow: visible;\n"])));
/**
 * A styled version of the  `<input type="checkbox">` component.
 *
 * Any props not mentiond here are passed through to the underlying `<input>` component.
 */


var Checkbox = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      style = _ref.style,
      label = _ref.label,
      rest = _objectWithoutProperties(_ref, ["className", "style", "label"]);

  var inlineLabel = label ? /*#__PURE__*/React.createElement("span", null, label) : null;
  return /*#__PURE__*/React.createElement(Wrapper, {
    className: className,
    style: style
  }, /*#__PURE__*/React.createElement(InteractionWrapper, null, /*#__PURE__*/React.createElement(_InteractionRipples["default"], {
    centered: true
  }), /*#__PURE__*/React.createElement(Input, _extends({
    ref: ref
  }, rest, {
    type: "checkbox"
  })), /*#__PURE__*/React.createElement(Display, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "2 1 28 28"
  }, /*#__PURE__*/React.createElement(Checkmark, {
    d: "M3.282996 18.517031l8.491595 8.175922 18.89864 -22.759994"
  }))), inlineLabel);
});
var _default = Checkbox;
exports["default"] = _default;